import { Button } from 'react-bootstrap';
import './StageActionSelectModal.scss';

type Props = {
    actionId: number;
    handleClose;
    handleSubmit;
};

const StageActionSelectModal = (props: Props): JSX.Element => {
    // const handleSubmit = (): void => {
    //     alert(props.actionId);
    // };

    return (
        <div className="change-name-container p-3">
            <div className="d-flex justify-content-between align-items-center">
                <Button className="btn-modify-width red-btn mt-3" onClick={(): void => props.handleClose()}>
                    キャンセル
                </Button>

                <Button className="btn-modify-width green-btn mt-3" onClick={(): void => props.handleSubmit()}>
                    決定
                </Button>
            </div>
        </div>
    );
};

export default StageActionSelectModal;
